import styled from "styled-components";

export const WhiteBox = styled.div`
  background-color: #fff;
  height: 110px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 15px;
`;
export const Box = styled.div`
  width: fit-content;
  font-size: 20px;
  padding-top: 15px;
`;

export const LanBox = styled.div`
    height: fit-content;
    font-size: 16px;
    width: 50px;
    background-color: rgba(185, 171, 96, 0.5);
    color: white;
    border-radius: 20px;
    text-align: center;
    font-weight: bold; 
`

export const SocialBox = styled.img`
    height: 27px;
    width: 27px;
    object-fit: cover;
`
export const BigSocialBox = styled.div`
    height: fit-content;
    width: 190px;
    margin-Top: 5px;
    display: flex;
    justify-content: space-between;
`
export const ChineseTopic = styled.div`
    font-size: 30px;
    color: #0a2980;
    letter-spacing: 16px;
`

export const ThaiTopic = styled.div`
    font-size: 15px;
    color: #0a2980;
    letter-spacing: 5px;
`

export const PicBox = styled.img`
    height: 145px;
    width: 145px;
    z-index: 100;
    object-fit: cover;
`